module.exports = "https://static.wanderu.com/ui-react/_next/static/media/phone-with-qr.4c3a9c6c.png";